import { 
  getProdutosScanned, deleteProdutoScanned, saveProdutoScanned, getProdutosStats, 
  enrichPendingProdutos, enrichSingleProduto, isValidEAN, getListasLocal, saveListaItemLocal, 
  getOpenShoppingLists, createQuickShoppingList, getCotacoesByEAN, resolvePendingCotacoes, 
  getFrequentStoresFromNotas 
} from '../db.js';
import { authManager } from '../auth-manager.js';
import { categorizeItem } from '../categorizer.js';

function formatBRL(val) {
  if (typeof val !== 'number' || isNaN(val)) return 'R$ 0,00';
  return `R$ ${val.toFixed(2).replace('.', ',')}`;
}

function escapeHTML(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export async function renderProdutosView(container, param, syncManager) {
  container.innerHTML = `
    <div class="view-header" style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 1.25rem; flex-wrap: wrap; gap: 0.75rem;">
      <div>
        <h2 style="font-size: 1.5rem; font-weight: 800; color: var(--text-main); margin: 0 0 0.25rem 0; display: flex; align-items: center; gap: 0.5rem;">
          <span class="material-symbols-outlined" style="font-size: 28px; color: var(--color-primary-text, #2563EB);">inventory_2</span>
          Catálogo de Produtos
        </h2>
        <p style="font-size: 0.84rem; color: var(--text-muted); margin: 0;">
          Base de dados consolidada com preços por supermercado e histórico de cotações.
        </p>
      </div>

      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <a href="#scanner-ai" class="btn btn-primary" style="font-size: 0.8rem; font-weight: 800; padding: 0.5rem 0.9rem; border-radius: var(--radius-pill); display: inline-flex; align-items: center; gap: 0.35rem; text-decoration: none; cursor: pointer;">
          <span class="material-symbols-outlined" style="font-size: 18px;">qr_code_scanner</span>
          <span>Escanear</span>
        </a>
      </div>
    </div>

    <!-- Stats KPIs Cards -->
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 0.75rem; margin-bottom: 1.25rem;">
      <div class="chart-card" style="padding: 0.85rem 1rem; border-radius: 0.85rem; background: var(--bg-surface); border: 1px solid var(--border-color);">
        <div style="font-size: 0.72rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.04em;">Total no Catálogo</div>
        <div id="stat-total-prods" style="font-size: 1.45rem; font-weight: 900; color: var(--text-main); font-family: var(--font-mono); margin-top: 0.2rem;">0</div>
      </div>
      <div class="chart-card" style="padding: 0.85rem 1rem; border-radius: 0.85rem; background: var(--bg-surface); border: 1px solid var(--border-color);">
        <div style="font-size: 0.72rem; font-weight: 700; color: #10B981; text-transform: uppercase; letter-spacing: 0.04em;">Identificados ✨</div>
        <div id="stat-enriquecidos-prods" style="font-size: 1.45rem; font-weight: 900; color: #10B981; font-family: var(--font-mono); margin-top: 0.2rem;">0</div>
      </div>
      <div class="chart-card" style="padding: 0.85rem 1rem; border-radius: 0.85rem; background: var(--bg-surface); border: 1px solid var(--border-color);">
        <div style="font-size: 0.72rem; font-weight: 700; color: #D97706; text-transform: uppercase; letter-spacing: 0.04em;">Pendentes ⏳</div>
        <div id="stat-pendentes-prods" style="font-size: 1.45rem; font-weight: 900; color: #D97706; font-family: var(--font-mono); margin-top: 0.2rem;">0</div>
      </div>
    </div>

    <!-- Search Bar -->
    <section class="search-bar" style="margin-bottom: 0.85rem;">
      <span class="material-symbols-outlined search-icon">search</span>
      <input type="text" id="input-search-produtos" class="search-input" placeholder="Buscar por nome, marca, mercado ou código EAN..." />
    </section>

    <!-- Category Filter Pills -->
    <div id="category-pills-container" style="display: flex; gap: 0.4rem; overflow-x: auto; padding-bottom: 0.4rem; margin-bottom: 1.15rem; -webkit-overflow-scrolling: touch;">
      <button class="cat-pill active" data-cat="ALL" style="padding: 0.3rem 0.75rem; border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; border: 1px solid var(--border-color); background: var(--color-primary, #2563EB); color: #FFF; cursor: pointer; white-space: nowrap;">
        Todos
      </button>
    </div>

    <!-- Products Catalog List -->
    <div id="produtos-list-container" style="display: flex; flex-direction: column; gap: 0.75rem; margin-bottom: 1.25rem;">
      <div style="text-align: center; padding: 2.5rem; color: var(--text-muted); font-size: 0.85rem;">
        Carregando catálogo de produtos...
      </div>
    </div>

    <!-- Collaborative Notice Footer -->
    <div style="text-align: center; margin: 1rem 0 2.5rem; padding: 0.65rem 0.9rem; border-radius: 0.75rem; background: var(--bg-surface-alt); border: 1px dashed var(--border-color); color: var(--text-muted); font-size: 0.75rem; display: flex; align-items: center; justify-content: center; gap: 0.4rem;">
      <span class="material-symbols-outlined" style="font-size: 16px; color: var(--color-primary-text, #2563EB); opacity: 0.8;">group_work</span>
      <span>Base colaborativa: o catálogo de produtos é compartilhado e enriquecido em comum para todos os usuários.</span>
    </div>

    <!-- Quick Add To Shopping List Modal -->
    <div id="prod-quick-add-list-modal" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 1005; padding: 1rem; box-sizing: border-box;">
      <div class="modal-card" style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 1.25rem; padding: 1.4rem; width: 100%; max-width: 440px; box-shadow: var(--shadow-card); box-sizing: border-box;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.85rem;">
          <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main); display: flex; align-items: center; gap: 0.4rem;">
            <span class="material-symbols-outlined" style="color: var(--color-primary-text, #2563EB); font-size: 22px;">add_shopping_cart</span>
            Adicionar à Lista de Compras
          </h4>
          <button id="btn-close-prod-quick-modal" type="button" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-muted); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
            <span class="material-symbols-outlined" style="font-size: 18px;">close</span>
          </button>
        </div>

        <div style="padding: 0.65rem 0.85rem; background: var(--bg-surface-alt); border-radius: 0.65rem; border: 1px solid var(--border-color); margin-bottom: 1rem;">
          <div id="modal-prod-title" style="font-size: 0.88rem; font-weight: 800; color: var(--text-main); line-height: 1.35; margin-bottom: 0.25rem;"></div>
          <div id="modal-prod-price" style="font-size: 0.82rem; font-weight: 700; color: #10B981; font-family: var(--font-mono);"></div>
        </div>
        
        <div style="margin-bottom: 1.15rem;">
          <label style="display: block; font-size: 0.74rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; margin-bottom: 0.45rem;">Quantidade</label>
          
          <!-- Stepper Touch-Friendly Controls -->
          <div style="display: flex; align-items: center; justify-content: center; gap: 0.65rem; margin-bottom: 0.65rem; width: 100%; box-sizing: border-box;">
            <button type="button" id="btn-prod-qty-minus" aria-label="Diminuir quantidade" style="width: 48px; height: 44px; min-width: 48px; border-radius: 0.65rem; font-size: 1.4rem; font-weight: 800; border: 1px solid var(--border-color); background: var(--bg-surface-alt); color: var(--text-main); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; user-select: none; transition: all 0.15s ease;">
              −
            </button>
            <input type="number" id="modal-prod-qty" value="1" min="0.1" step="any" inputmode="decimal" style="flex: 1; max-width: 130px; height: 44px; text-align: center; font-size: 1.25rem; font-weight: 800; border-radius: 0.65rem; border: 1px solid var(--border-color); background: var(--bg-surface-dim, var(--bg-surface-alt)); color: var(--text-main); outline: none; font-family: var(--font-mono); box-sizing: border-box;" />
            <button type="button" id="btn-prod-qty-plus" aria-label="Aumentar quantidade" style="width: 48px; height: 44px; min-width: 48px; border-radius: 0.65rem; font-size: 1.4rem; font-weight: 800; border: 1px solid var(--border-color); background: var(--bg-surface-alt); color: var(--text-main); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; user-select: none; transition: all 0.15s ease;">
              +
            </button>
          </div>

          <!-- Quick Increment & Weight Shortcuts -->
          <div style="display: flex; gap: 0.35rem; justify-content: center; flex-wrap: wrap;">
            <button type="button" class="btn-prod-qty-preset" data-delta="1" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-main); border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; padding: 0.3rem 0.65rem; cursor: pointer; transition: all 0.15s ease;">+1</button>
            <button type="button" class="btn-prod-qty-preset" data-delta="2" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-main); border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; padding: 0.3rem 0.65rem; cursor: pointer; transition: all 0.15s ease;">+2</button>
            <button type="button" class="btn-prod-qty-preset" data-delta="5" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-main); border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; padding: 0.3rem 0.65rem; cursor: pointer; transition: all 0.15s ease;">+5</button>
            <button type="button" class="btn-prod-qty-preset" data-set="0.5" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-muted); border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; padding: 0.3rem 0.65rem; cursor: pointer; transition: all 0.15s ease;">0.5 kg</button>
            <button type="button" class="btn-prod-qty-preset" data-set="1" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-muted); border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; padding: 0.3rem 0.65rem; cursor: pointer; transition: all 0.15s ease;">Reset (1)</button>
          </div>
        </div>

        <label style="display: block; font-size: 0.74rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; margin-bottom: 0.45rem;">Selecione a Lista de Destino</label>
        <div id="modal-prod-list-options" style="display: flex; flex-direction: column; gap: 0.5rem; max-height: 200px; overflow-y: auto; margin-bottom: 1.15rem;">
          <!-- Populated dynamically -->
        </div>

        <button id="btn-cancel-prod-quick-modal" type="button" class="btn btn-secondary" style="width: 100%; padding: 0.65rem; border-radius: var(--radius-pill); font-weight: 700; cursor: pointer;">
          Cancelar
        </button>
      </div>
    </div>

    <!-- Modal: Resolve Store for Pending Quotes -->
    <div id="modal-resolve-store" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 1006; padding: 1rem; box-sizing: border-box;">
      <div class="modal-card" style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 1.25rem; padding: 1.4rem; width: 100%; max-width: 440px; box-shadow: var(--shadow-card); box-sizing: border-box;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.85rem;">
          <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main); display: flex; align-items: center; gap: 0.4rem;">
            <span class="material-symbols-outlined" style="color: #D97706; font-size: 22px;">storefront</span>
            Definir Estabelecimento
          </h4>
          <button id="btn-close-resolve-store" type="button" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-muted); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
            <span class="material-symbols-outlined" style="font-size: 18px;">close</span>
          </button>
        </div>

        <p style="font-size: 0.82rem; color: var(--text-muted); margin: 0 0 0.85rem 0;">
          Associe o supermercado onde este preço foi observado para enriquecer as cotações:
        </p>

        <div style="margin-bottom: 0.85rem;">
          <label style="display: block; font-size: 0.72rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; margin-bottom: 0.35rem;">Estabelecimentos Frequentes</label>
          <div id="resolve-store-pills" style="display: flex; flex-wrap: wrap; gap: 0.35rem; margin-bottom: 0.75rem;">
            <!-- Populated dynamically -->
          </div>
        </div>

        <div style="margin-bottom: 1.15rem;">
          <label for="input-custom-store-name" style="display: block; font-size: 0.72rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; margin-bottom: 0.35rem;">Ou digite outro estabelecimento</label>
          <input type="text" id="input-custom-store-name" placeholder="Ex: Supermercados Guanabara, Assaí..." style="width: 100%; padding: 0.6rem 0.85rem; border: 1px solid var(--border-color); border-radius: 0.6rem; background: var(--bg-surface-alt); color: var(--text-main); font-weight: 700; font-size: 0.92rem; box-sizing: border-box; outline: none;" />
        </div>

        <div style="display: flex; gap: 0.5rem;">
          <button id="btn-save-resolve-store" type="button" class="btn btn-primary" style="flex: 1; padding: 0.65rem; border-radius: var(--radius-pill); font-weight: 800; cursor: pointer;">
            Confirmar
          </button>
          <button id="btn-cancel-resolve-store" type="button" class="btn btn-secondary" style="padding: 0.65rem 1rem; border-radius: var(--radius-pill); font-weight: 700; cursor: pointer;">
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Confirm Delete Product from Catalog (Standard App Modal) -->
    <div id="modal-delete-prod-catalog" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); backdrop-filter: blur(8px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 1rem; box-sizing: border-box;">
      <div class="modal-card" style="background: var(--bg-surface); border-radius: 1.25rem; border: 1px solid var(--border-color); box-shadow: var(--shadow-card); max-width: 400px; width: 100%; padding: 1.75rem 1.5rem; text-align: center; box-sizing: border-box;">
        <div style="width: 48px; height: 48px; border-radius: 50%; background: var(--color-danger-bg, #FEF2F2); color: var(--color-danger, #DC2626); display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem auto; border: 1px solid var(--color-danger-border, #FECDD3);">
          <span class="material-symbols-outlined" style="font-size: 24px;">delete</span>
        </div>
        <h3 style="font-weight: 800; font-size: 1.15rem; color: var(--text-main); margin: 0 0 0.4rem 0;">Excluir Produto?</h3>
        <p class="text-muted" style="font-size: 0.85rem; line-height: 1.45; margin: 0 0 1.25rem 0;">
          Deseja realmente remover o produto <strong id="delete-prod-modal-desc" style="color: var(--text-main);">-</strong> do catálogo?
        </p>
        <div style="display: flex; gap: 0.5rem;">
          <button type="button" class="btn btn-secondary" id="btn-cancel-delete-prod" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700; height: 40px; cursor: pointer;">
            Cancelar
          </button>
          <button type="button" class="btn btn-danger" id="btn-confirm-delete-prod" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700; background: #DC2626; color: #FFF; border: none; height: 40px; cursor: pointer;">
            Sim, Excluir
          </button>
        </div>
      </div>
    </div>
  `;

  // State
  let allProdutos = [];
  let currentCategory = 'ALL';
  let searchQuery = '';
  let activeSelectedProd = null;
  let currentDisplayLimit = 30;

  const statTotal = container.querySelector('#stat-total-prods');
  const statEnriquecidos = container.querySelector('#stat-enriquecidos-prods');
  const statPendentes = container.querySelector('#stat-pendentes-prods');
  const searchInput = container.querySelector('#input-search-produtos');
  const categoryPillsContainer = container.querySelector('#category-pills-container');
  const listContainer = container.querySelector('#produtos-list-container');

  const quickModal = container.querySelector('#prod-quick-add-list-modal');
  const btnCloseModal = container.querySelector('#btn-close-prod-quick-modal');
  const btnCancelModal = container.querySelector('#btn-cancel-prod-quick-modal');
  const modalTitle = container.querySelector('#modal-prod-title');
  const modalPrice = container.querySelector('#modal-prod-price');
  const modalQty = container.querySelector('#modal-prod-qty');
  const modalListOptions = container.querySelector('#modal-prod-list-options');

  async function loadData() {
    allProdutos = await getProdutosScanned();
    allProdutos.sort((a, b) => {
      const nameA = (a.descricao || a.descricao_bruta || '').trim();
      const nameB = (b.descricao || b.descricao_bruta || '').trim();
      return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base', numeric: true });
    });
    renderStats();
    renderCategoryPills();
    renderList();
  }

  function renderStats() {
    const total = allProdutos.length;
    const enriquecidos = allProdutos.filter(p => p.status === 'enriquecido' && p.descricao && p.descricao !== 'Produto sem descrição').length;
    const pendentes = total - enriquecidos;

    statTotal.textContent = total;
    statEnriquecidos.textContent = enriquecidos;
    statPendentes.textContent = pendentes;
  }

  function renderCategoryPills() {
    const categories = Array.from(new Set(allProdutos.map(p => p.categoria || 'Outros').filter(Boolean)));
    categories.sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));

    categoryPillsContainer.innerHTML = `
      <button class="cat-pill ${currentCategory === 'ALL' ? 'active' : ''}" data-cat="ALL" style="padding: 0.3rem 0.75rem; border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; border: 1px solid var(--border-color); background: ${currentCategory === 'ALL' ? 'var(--color-primary, #2563EB)' : 'var(--bg-surface-alt)'}; color: ${currentCategory === 'ALL' ? '#FFF' : 'var(--text-main)'}; cursor: pointer; white-space: nowrap;">
        Todos (${allProdutos.length})
      </button>
      ${categories.map(cat => {
        const count = allProdutos.filter(p => (p.categoria || 'Outros') === cat).length;
        const isActive = currentCategory === cat;
        return `
          <button class="cat-pill ${isActive ? 'active' : ''}" data-cat="${escapeHTML(cat)}" style="padding: 0.3rem 0.75rem; border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; border: 1px solid var(--border-color); background: ${isActive ? 'var(--color-primary, #2563EB)' : 'var(--bg-surface-alt)'}; color: ${isActive ? '#FFF' : 'var(--text-main)'}; cursor: pointer; white-space: nowrap;">
            ${escapeHTML(cat)} (${count})
          </button>
        `;
      }).join('')}
    `;

    categoryPillsContainer.querySelectorAll('.cat-pill').forEach(btn => {
      btn.addEventListener('click', () => {
        currentCategory = btn.getAttribute('data-cat');
        currentDisplayLimit = 30;
        renderCategoryPills();
        renderList();
      });
    });
  }

  function renderList() {
    const q = searchQuery.toLowerCase().trim();
    let filtered = allProdutos.filter(p => {
      if (currentCategory !== 'ALL' && (p.categoria || 'Outros') !== currentCategory) {
        return false;
      }
      if (q) {
        const matchName = (p.descricao || '').toLowerCase().includes(q);
        const matchEAN = (p.barcode || p.ean || '').toLowerCase().includes(q);
        const matchMarca = (p.marca || '').toLowerCase().includes(q);
        const matchCat = (p.categoria || '').toLowerCase().includes(q);
        return matchName || matchEAN || matchMarca || matchCat;
      }
      return true;
    });

    // Ordenação alfabética padronizada por nome do produto
    filtered.sort((a, b) => {
      const nameA = (a.descricao || a.descricao_bruta || '').trim();
      const nameB = (b.descricao || b.descricao_bruta || '').trim();
      return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base', numeric: true });
    });

    if (filtered.length === 0) {
      listContainer.innerHTML = `
        <div class="chart-card text-center text-muted" style="padding: 2.5rem 1.5rem; font-size: 0.875rem; border-radius: 1rem;">
          <span class="material-symbols-outlined" style="font-size: 36px; opacity: 0.4; display: block; margin-bottom: 0.5rem;">inventory_2</span>
          ${allProdutos.length === 0 ? 'Nenhum produto cadastrado no catálogo ainda. Escaneie um código de barras ou etiqueta para começar!' : 'Nenhum produto encontrado com os filtros selecionados.'}
        </div>
      `;
      return;
    }

    const totalFiltered = filtered.length;
    const visibleProducts = filtered.slice(0, currentDisplayLimit);

    const cardsHTML = visibleProducts.map(prod => {
      const displayPrice = typeof prod.rawPrecoGondola === 'number'
        ? prod.rawPrecoGondola
        : (typeof prod.preco === 'number' ? prod.preco : (parseFloat(prod.precoGondola?.replace(/[^\d,]/g, '').replace(',', '.')) || 0));

      const isEnriched = prod.status === 'enriquecido' && prod.descricao && prod.descricao !== 'Produto sem descrição';
      const isPendingStore = !!prod.pendente_estabelecimento || !!prod.pendenteEstabelecimento || prod.ultimoMercado === 'Não informado';
      const scanCount = prod.scanCount || 1;
      const historyCount = Array.isArray(prod.historicoPrecos) ? prod.historicoPrecos.length : 0;
      const ean = prod.barcode || prod.ean || '';

      return `
        <div class="chart-card product-item-card" data-id="${prod.id}" data-ean="${ean}" style="padding: 0.9rem 1.1rem; border-radius: 1rem; background: var(--bg-surface); border: 1px solid var(--border-color); display: flex; flex-direction: column; gap: 0.5rem; box-shadow: var(--shadow-card); transition: transform 120ms ease;">
          
          <!-- Row 1: EAN Badge + Sparkle Icon + Price -->
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            <div style="display: flex; align-items: center; gap: 0.35rem; flex-wrap: wrap;">
              <span class="font-mono font-bold" style="font-size: 0.75rem; color: var(--text-main); background: var(--bg-surface-dim); border: 1px solid var(--border-color); padding: 0.12rem 0.45rem; border-radius: 0.35rem; white-space: nowrap;">
                ${ean || 'SEM EAN'}
              </span>
              ${isEnriched ? `
                <span title="Identificado por IA" style="font-size: 0.95rem; line-height: 1; display: inline-flex; align-items: center; margin-left: 0.15rem;">✨</span>
              ` : `
                <span style="font-size: 0.68rem; background: var(--color-warning-bg, #FFFBEB); border: 1px solid var(--color-warning-border, #FDE68A); color: var(--color-warning-text, #92400E); font-weight: 700; padding: 0.1rem 0.45rem; border-radius: var(--radius-pill); display: inline-flex; align-items: center; gap: 0.2rem; white-space: nowrap;">
                  ⏳ Pendente
                </span>
              `}
              ${isPendingStore ? `
                <button type="button" class="btn-open-resolve-store" data-ean="${ean}" style="background: rgba(245, 158, 11, 0.15); border: 1px solid rgba(245, 158, 11, 0.35); color: #d97706; font-size: 0.68rem; font-weight: 700; padding: 0.1rem 0.45rem; border-radius: var(--radius-pill); cursor: pointer; display: inline-flex; align-items: center; gap: 0.2rem;">
                  <span class="material-symbols-outlined" style="font-size: 13px;">edit_location</span>
                  <span>Definir Mercado</span>
                </button>
              ` : ''}
            </div>

            <div style="text-align: right;">
              <span class="font-mono font-bold" style="font-size: 1.15rem; color: #10B981; white-space: nowrap; flex-shrink: 0;">
                ${formatBRL(displayPrice)}
              </span>
              ${prod.menorPreco && prod.menorPreco > 0 && prod.menorPreco < displayPrice ? `
                <div style="font-size: 0.68rem; color: var(--text-muted);">
                  Menor: <strong style="color: #10B981;">${formatBRL(prod.menorPreco)}</strong> (${escapeHTML(prod.menorMercado || 'Loja')})
                </div>
              ` : ''}
            </div>
          </div>

          <!-- Row 2: Product Name (Full width with 2-line clamp support) -->
          <div style="width: 100%; min-width: 0; overflow: hidden;">
            <h3 style="margin: 0; font-size: 0.96rem; font-weight: 800; color: var(--text-main); line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-break: break-word;" title="${escapeHTML(prod.descricao || 'Produto sem descrição')}">
              ${escapeHTML(prod.descricao || 'Produto sem descrição')}
            </h3>
          </div>

          <!-- Row 3: Category, Brand, Weight & Scans -->
          <div style="display: flex; align-items: center; gap: 0.35rem; font-size: 0.72rem; color: var(--text-muted); flex-wrap: wrap;">
            <span style="background: var(--bg-surface-alt); border: 1px solid var(--border-color); padding: 0.08rem 0.4rem; border-radius: 0.3rem; color: var(--text-muted); font-weight: 600;">
              ${escapeHTML(prod.categoria || 'Outros')}
            </span>
            ${prod.marca ? `<span style="color: var(--text-subtle); font-weight: 600;">• ${escapeHTML(prod.marca)}</span>` : ''}
            ${prod.peso_ou_quantidade ? `<span style="color: var(--text-subtle);">• ${escapeHTML(prod.peso_ou_quantidade)}</span>` : ''}
            <span>• ${scanCount} leitura${scanCount === 1 ? '' : 's'}</span>
            ${historyCount > 0 ? `<span>• ${historyCount} cotaç${historyCount === 1 ? 'ão' : 'ões'}</span>` : ''}
            ${prod.ultimoMercado ? `<span>• <em>${escapeHTML(prod.ultimoMercado)}</em></span>` : ''}
          </div>

          <!-- Accordion Toggle Button for Supermarket Quotes -->
          <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 0.35rem; border-top: 1px dashed var(--border-color); margin-top: 0.1rem;">
            <button type="button" class="btn-toggle-quotes" data-ean="${ean}" style="background: none; border: none; font-size: 0.76rem; font-weight: 700; color: var(--color-primary-text, #2563EB); cursor: pointer; display: inline-flex; align-items: center; gap: 0.25rem; padding: 0.2rem 0;">
              <span class="material-symbols-outlined" style="font-size: 16px;">storefront</span>
              <span>Cotações por Mercado</span>
              <span class="material-symbols-outlined arrow-icon" style="font-size: 16px; transition: transform 150ms ease;">expand_more</span>
            </button>

            <!-- Row 4: Action Buttons Bar -->
            <div style="display: flex; align-items: center; gap: 0.45rem;">
              ${!isEnriched ? `
                <button class="btn btn-primary btn-enrich-single-prod" data-id="${prod.id}" title="Identificar dados do produto com IA" style="padding: 0.3rem 0.7rem; font-size: 0.75rem; font-weight: 800; border-radius: var(--radius-pill); display: inline-flex; align-items: center; gap: 0.25rem; cursor: pointer; white-space: nowrap;">
                  <span class="material-symbols-outlined icon-sparkle" style="font-size: 15px;">auto_awesome</span>
                  <span>Identificar</span>
                </button>
              ` : ''}

              <button class="btn-add-list-catalog btn btn-secondary" data-id="${prod.id}" title="Adicionar à Lista de Compras" style="padding: 0.3rem 0.7rem; font-size: 0.75rem; font-weight: 800; border-radius: var(--radius-pill); display: inline-flex; align-items: center; gap: 0.25rem; cursor: pointer; white-space: nowrap;">
                <span class="material-symbols-outlined" style="font-size: 15px; color: var(--color-primary-text, #2563EB);">add_shopping_cart</span>
                + Lista
              </button>

              <button class="btn-delete-prod-catalog" data-id="${prod.id}" title="Excluir produto" style="background: none; border: none; color: var(--text-muted); cursor: pointer; padding: 0.25rem; display: flex; align-items: center;">
                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
              </button>
            </div>
          </div>

          <!-- Expandable Quotes Container -->
          <div class="quotes-accordion-container" data-ean="${ean}" style="display: none; padding: 0.65rem 0.75rem; background: var(--bg-surface-alt); border-radius: 0.65rem; border: 1px solid var(--border-color); margin-top: 0.35rem;">
            <div style="font-size: 0.75rem; color: var(--text-muted); text-align: center;">Carregando cotações...</div>
          </div>

        </div>
      `;
    }).join('');

    const loadMoreHTML = totalFiltered > currentDisplayLimit ? `
      <div style="text-align: center; margin-top: 1rem;">
        <button id="btn-load-more-produtos" class="btn btn-secondary" style="padding: 0.6rem 1.25rem; font-size: 0.82rem; font-weight: 700; border-radius: var(--radius-pill); cursor: pointer; display: inline-flex; align-items: center; gap: 0.35rem;">
          <span class="material-symbols-outlined" style="font-size: 18px;">expand_more</span>
          <span>Carregar mais produtos (mostrando ${visibleProducts.length} de ${totalFiltered})</span>
        </button>
      </div>
    ` : '';

    listContainer.innerHTML = cardsHTML + loadMoreHTML;

    const btnLoadMore = listContainer.querySelector('#btn-load-more-produtos');
    if (btnLoadMore) {
      btnLoadMore.addEventListener('click', () => {
        currentDisplayLimit += 30;
        renderList();
      });
    }

    // Bind action events
    listContainer.querySelectorAll('.btn-enrich-single-prod').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-id');
        const prod = allProdutos.find(p => String(p.id) === String(id));
        if (!prod) return;

        const ean = (prod.ean || prod.barcode || '').trim();
        const isEanValid = isValidEAN(ean);
        const rawDesc = (prod.descricao_bruta || prod.descricao || '').trim();
        const isGeneric = !rawDesc || rawDesc === 'Produto sem descrição' || rawDesc === 'Produto sem descrição OCR';

        if (!isEanValid && isGeneric) {
          if (syncManager?.showToast) {
            syncManager.showToast('Código de barras inválido para consulta global por IA.', 'warning');
          }
          return;
        }

        btn.disabled = true;
        const origHTML = btn.innerHTML;
        btn.innerHTML = `<span class="material-symbols-outlined" style="font-size: 14px; animation: spin 1s linear infinite;">sync</span> <span>Identificando...</span>`;

        try {
          const enriched = await enrichSingleProduto(prod);
          if (enriched && enriched.status === 'enriquecido') {
            syncManager.showToast(`Produto "${enriched.descricao}" identificado com sucesso!`, 'success');
            await loadData();
          } else {
            syncManager.showToast('Nenhum dado encontrado para este código.', 'warning');
            btn.innerHTML = origHTML;
            btn.disabled = false;
          }
        } catch (err) {
          console.warn('Erro ao identificar produto:', err);
          syncManager.showToast(err.message || 'Falha ao identificar por IA.', 'error');
          btn.innerHTML = origHTML;
          btn.disabled = false;
        }
      });
    });

    listContainer.querySelectorAll('.btn-delete-prod-catalog').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-id');
        const prod = allProdutos.find(p => String(p.id) === String(id) || String(p.ean) === String(id) || String(p.barcode) === String(id));
        if (prod) {
          openDeleteModal(prod);
        }
      });
    });

    // Accordion Toggle for Supermarket Quotes
    listContainer.querySelectorAll('.btn-toggle-quotes').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const ean = btn.getAttribute('data-ean');
        const card = btn.closest('.product-item-card');
        const containerAccordion = card.querySelector(`.quotes-accordion-container[data-ean="${ean}"]`);
        const arrow = btn.querySelector('.arrow-icon');
        if (!containerAccordion) return;

        const isExpanded = containerAccordion.style.display !== 'none';
        if (isExpanded) {
          containerAccordion.style.display = 'none';
          if (arrow) arrow.style.transform = 'rotate(0deg)';
        } else {
          containerAccordion.style.display = 'block';
          if (arrow) arrow.style.transform = 'rotate(180deg)';

          try {
            const cotacoes = await getCotacoesByEAN(ean);
            if (!cotacoes || cotacoes.length === 0) {
              containerAccordion.innerHTML = `
                <div style="font-size: 0.76rem; color: var(--text-muted); text-align: center; padding: 0.35rem;">
                  Nenhuma cotação detalhada registrada para este EAN.
                </div>
              `;
              return;
            }

            // Group quotes by store
            const storeGroups = new Map();
            let globalLowestPrice = Infinity;

            for (const q of cotacoes) {
              const price = typeof q.preco === 'number' ? q.preco : (parseFloat(q.preco) || 0);
              if (price > 0 && price < globalLowestPrice) {
                globalLowestPrice = price;
              }
              const storeKey = (q.mercado && q.mercado.trim()) ? q.mercado.trim() : 'Não informado';
              if (!storeGroups.has(storeKey)) {
                storeGroups.set(storeKey, []);
              }
              storeGroups.get(storeKey).push(q);
            }

            // Sort stores by their lowest price
            const sortedStores = Array.from(storeGroups.entries()).map(([storeName, quotes]) => {
              const sortedQuotes = [...quotes].sort((a, b) => (a.preco || 0) - (b.preco || 0));
              const bestPrice = sortedQuotes[0]?.preco || 0;
              const isPendente = storeName === 'Não informado' || quotes.some(q => q.statusEstabelecimento === 'pendente' || q.status_estabelecimento === 'pendente');
              const pendingQuoteIds = quotes.filter(q => q.statusEstabelecimento === 'pendente' || q.status_estabelecimento === 'pendente' || storeName === 'Não informado').map(q => q.id);
              return { storeName, quotes: sortedQuotes, bestPrice, isPendente, pendingQuoteIds };
            }).sort((a, b) => a.bestPrice - b.bestPrice);

            containerAccordion.innerHTML = `
              <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                <div style="font-size: 0.72rem; font-weight: 800; color: var(--text-muted); text-transform: uppercase; margin-bottom: 0.1rem; display: flex; justify-content: space-between;">
                  <span>Cotações por Estabelecimento (${cotacoes.length})</span>
                  <span>Preço</span>
                </div>

                ${sortedStores.map((sg, sIdx) => `
                  <div class="store-quotes-card" style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 0.6rem; overflow: hidden;">
                    <!-- Store Header (Name appears only once here) -->
                    <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.4rem 0.65rem; background: var(--bg-surface-dim); border-bottom: 1px solid var(--border-color);">
                      <div style="display: flex; align-items: center; gap: 0.35rem; min-width: 0;">
                        <span style="font-weight: 800; color: ${sg.bestPrice === globalLowestPrice ? '#10B981' : 'var(--text-muted)'}; font-size: 0.72rem;">#${sIdx + 1}</span>
                        <span class="material-symbols-outlined" style="font-size: 15px; color: var(--color-primary-text, #2563EB);">storefront</span>
                        <span style="font-weight: 700; font-size: 0.8rem; color: var(--text-main); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          ${escapeHTML(sg.storeName)}
                        </span>
                      </div>
                      ${sg.isPendente ? `
                        <button type="button" class="btn-open-resolve-group" data-ids="${sg.pendingQuoteIds.join(',')}" data-ean="${ean}" style="background: rgba(245,158,11,0.15); border: 1px solid rgba(245,158,11,0.3); color: #d97706; font-size: 0.68rem; font-weight: 700; padding: 0.12rem 0.45rem; border-radius: var(--radius-pill); cursor: pointer; display: inline-flex; align-items: center; gap: 0.2rem;">
                          <span class="material-symbols-outlined" style="font-size: 12px;">edit_location</span>
                          Definir
                        </button>
                      ` : ''}
                    </div>

                    <!-- Store Quotes List (No store name repetition, compact single line) -->
                    <div style="display: flex; flex-direction: column;">
                      ${sg.quotes.map((q, qIdx) => {
                        const d = q.createdAt || q.created_at ? new Date(q.createdAt || q.created_at) : null;
                        const dateFormatted = d ? `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}` : '';
                        const sourceIcon = (q.tipoFonte === 'nfce' || q.tipo_fonte === 'nfce') ? 'receipt_long' : 'crop_free';
                        const sourceLabel = (q.tipoFonte === 'nfce' || q.tipo_fonte === 'nfce') ? 'NFC-e' : 'Scanner';
                        const isGlobalLowest = q.preco === globalLowestPrice && q.preco > 0;
                        const rawUserName = (q.userName || q.user_name || '').trim();
                        const shortUser = rawUserName ? rawUserName.split(' ')[0] : '';

                        return `
                          <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.35rem 0.65rem; font-size: 0.76rem; ${qIdx < sg.quotes.length - 1 ? 'border-bottom: 1px dashed var(--border-color);' : ''}">
                            <div style="display: flex; align-items: center; gap: 0.35rem; color: var(--text-muted); font-size: 0.72rem; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                              <span class="material-symbols-outlined" style="font-size: 13px; flex-shrink: 0;" title="${sourceLabel}">${sourceIcon}</span>
                              <span style="white-space: nowrap;">${dateFormatted}</span>
                              ${shortUser ? `<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">• ${escapeHTML(shortUser)}</span>` : ''}
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.35rem; flex-shrink: 0; margin-left: 0.5rem; white-space: nowrap;">
                              <span class="font-mono" style="font-weight: 800; color: ${isGlobalLowest ? '#10B981' : 'var(--text-main)'}; font-size: 0.88rem;">
                                ${formatBRL(q.preco)}
                              </span>
                              ${isGlobalLowest ? `<span style="font-size: 0.62rem; background: rgba(16,185,129,0.15); color: #10B981; padding: 0.05rem 0.3rem; border-radius: 0.25rem; font-weight: 700;">Menor</span>` : ''}
                            </div>
                          </div>
                        `;
                      }).join('')}
                    </div>
                  </div>
                `).join('')}
              </div>
            `;

            containerAccordion.querySelectorAll('.btn-open-resolve-group').forEach(b => {
              b.addEventListener('click', (ev) => {
                ev.stopPropagation();
                const qIds = (b.getAttribute('data-ids') || '').split(',').filter(Boolean);
                openResolveStoreModal(qIds, ean);
              });
            });

          } catch (err) {
            console.warn('[ProdutosView] quotes load error:', err);
            containerAccordion.innerHTML = '<div style="font-size: 0.76rem; color: var(--text-muted); text-align: center;">Erro ao carregar cotações.</div>';
          }
        }
      });
    });

    // Resolve Store Button on Card Header
    listContainer.querySelectorAll('.btn-open-resolve-store').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const ean = btn.getAttribute('data-ean');
        const cotacoes = await getCotacoesByEAN(ean);
        const pendingIds = (cotacoes || [])
          .filter(c => c.statusEstabelecimento === 'pendente' || c.status_estabelecimento === 'pendente' || c.mercado === 'Não informado')
          .map(c => c.id);
        openResolveStoreModal(pendingIds, ean);
      });
    });

    listContainer.querySelectorAll('.btn-add-list-catalog').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-id');
        const prod = allProdutos.find(p => String(p.id) === String(id));
        if (prod) {
          openQuickAddModal(prod);
        }
      });
    });
  }

  async function openQuickAddModal(prod) {
    activeSelectedProd = prod;
    modalTitle.textContent = prod.descricao || 'Produto do Catálogo';
    const numPrice = typeof prod.preco === 'number' && prod.preco > 0 
      ? prod.preco 
      : (typeof prod.rawPrecoGondola === 'number' ? prod.rawPrecoGondola : 0);
    modalPrice.textContent = numPrice > 0 ? formatBRL(numPrice) : 'Preço não definido';
    modalQty.value = '1';

    async function renderListOptions() {
      modalListOptions.innerHTML = '<div style="text-align: center; padding: 1rem; color: var(--text-muted); font-size: 0.82rem;">Carregando listas...</div>';

      try {
        const openLists = await getOpenShoppingLists();

        if (openLists.length === 0) {
          modalListOptions.innerHTML = `
            <div style="text-align: center; padding: 1rem 0.5rem;">
              <span class="material-symbols-outlined" style="font-size: 32px; color: var(--text-muted); opacity: 0.6; display: block; margin-bottom: 0.35rem;">playlist_add</span>
              <p style="margin: 0 0 0.85rem 0; color: var(--text-muted); font-size: 0.84rem;">Nenhuma lista aberta encontrada.</p>
              <button type="button" id="btn-create-quick-list-catalog" class="btn btn-primary" style="padding: 0.55rem 1rem; font-size: 0.82rem; font-weight: 800; border-radius: var(--radius-pill); display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer;">
                <span class="material-symbols-outlined" style="font-size: 16px;">add</span>
                Criar Nova Lista "Minhas Compras"
              </button>
            </div>
          `;

          const btnCreate = modalListOptions.querySelector('#btn-create-quick-list-catalog');
          if (btnCreate) {
            btnCreate.addEventListener('click', async () => {
              btnCreate.disabled = true;
              btnCreate.textContent = 'Criando lista...';
              const newList = await createQuickShoppingList('Minhas Compras', 'personal');
              if (newList && newList.id) {
                await addProdToTargetList(newList.id);
              }
            });
          }
        } else {
          modalListOptions.innerHTML = `
            ${openLists.map(l => `
              <button type="button" class="btn-select-catalog-target-list" data-list-id="${l.id}" style="display: flex; align-items: center; justify-content: space-between; padding: 0.65rem 0.85rem; border: 1px solid var(--border-color); border-radius: 0.65rem; background: var(--bg-surface); cursor: pointer; text-align: left; transition: all 120ms ease; gap: 0.5rem; width: 100%;">
                <div style="min-width: 0;">
                  <div style="font-weight: 700; font-size: 0.86rem; color: var(--text-main); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    ${escapeHTML(l.name || l.title || l.nome || 'Lista de Compras')}
                  </div>
                  <div style="font-size: 0.7rem; color: var(--text-muted);">
                    ${l.scope === 'family' ? '👨‍👩‍👧 Família' : '👤 Pessoal'}
                  </div>
                </div>
                <span class="material-symbols-outlined" style="font-size: 18px; color: var(--color-primary-text, #2563EB);">add_circle</span>
              </button>
            `).join('')}
            <div style="margin-top: 0.4rem; text-align: center;">
              <button type="button" id="btn-create-another-catalog-list" style="background: none; border: none; font-size: 0.75rem; color: var(--color-primary-text, #2563EB); font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 0.2rem;">
                <span class="material-symbols-outlined" style="font-size: 15px;">add</span>
                Criar outra lista
              </button>
            </div>
          `;

          modalListOptions.querySelectorAll('.btn-select-catalog-target-list').forEach(btn => {
            btn.addEventListener('click', async () => {
              const listId = Number(btn.getAttribute('data-list-id'));
              if (listId) {
                await addProdToTargetList(listId);
              }
            });
          });

          const btnAnother = modalListOptions.querySelector('#btn-create-another-catalog-list');
          if (btnAnother) {
            btnAnother.addEventListener('click', async () => {
              const title = prompt('Nome da nova lista de compras:', 'Compras');
              if (title && title.trim()) {
                const newList = await createQuickShoppingList(title.trim(), 'personal');
                if (newList && newList.id) {
                  await addProdToTargetList(newList.id);
                }
              }
            });
          }
        }
      } catch (e) {
        console.warn('Erro ao abrir modal de listas:', e);
        modalListOptions.innerHTML = '<div style="text-align: center; padding: 1rem; color: var(--text-muted); font-size: 0.82rem;">Erro ao carregar listas.</div>';
      }
    }

    async function addProdToTargetList(listId) {
      const qty = parseFloat(modalQty.value) || 1;
      if (listId && activeSelectedProd) {
        const catInfo = categorizeItem(activeSelectedProd.descricao);
        const itemPayload = {
          listId,
          description: activeSelectedProd.descricao || 'Produto do Catálogo',
          quantity: qty,
          unit: activeSelectedProd.peso_ou_quantidade || 'UN',
          estimatedPrice: numPrice,
          actualPrice: 0,
          categoryName: activeSelectedProd.categoria || catInfo?.nome || 'Outros',
          barcode: activeSelectedProd.ean || activeSelectedProd.barcode || '',
          isChecked: false,
          actualQuantity: 0,
        };

        if (authManager.isAuthenticated()) {
          try {
            const res = await authManager.fetchWithAuth(`/api/listas/${listId}/itens`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(itemPayload),
            });
            if (res.ok) {
              const created = await res.json();
              await saveListaItemLocal(created);
            } else {
              await saveListaItemLocal(itemPayload);
            }
          } catch {
            await saveListaItemLocal(itemPayload);
          }
        } else {
          await saveListaItemLocal(itemPayload);
        }

        quickModal.classList.add('hidden');
        syncManager.showToast('Item adicionado à lista com sucesso!', 'success');
      }
    }

    await renderListOptions();
    quickModal.classList.remove('hidden');
  }

  function closeQuickModal() {
    quickModal.classList.add('hidden');
    activeSelectedProd = null;
  }

  if (btnCloseModal) btnCloseModal.addEventListener('click', closeQuickModal);
  if (btnCancelModal) btnCancelModal.addEventListener('click', closeQuickModal);

  // Stepper quantity controls
  const btnProdQtyMinus = container.querySelector('#btn-prod-qty-minus');
  const btnProdQtyPlus = container.querySelector('#btn-prod-qty-plus');

  if (btnProdQtyMinus && modalQty) {
    btnProdQtyMinus.addEventListener('click', () => {
      let currentVal = parseFloat(modalQty.value) || 1;
      if (currentVal > 1) {
        currentVal = Math.max(1, currentVal - 1);
      } else if (currentVal > 0.5) {
        currentVal = 0.5;
      } else if (currentVal > 0.1) {
        currentVal = Math.max(0.1, Number((currentVal - 0.1).toFixed(1)));
      }
      modalQty.value = currentVal;
    });
  }

  if (btnProdQtyPlus && modalQty) {
    btnProdQtyPlus.addEventListener('click', () => {
      let currentVal = parseFloat(modalQty.value) || 0;
      if (currentVal < 1) {
        currentVal = 1;
      } else {
        currentVal = Math.floor(currentVal) + 1;
      }
      modalQty.value = currentVal;
    });
  }

  container.querySelectorAll('.btn-prod-qty-preset').forEach(btn => {
    btn.addEventListener('click', () => {
      const delta = btn.getAttribute('data-delta');
      const setVal = btn.getAttribute('data-set');
      if (delta) {
        const add = parseFloat(delta) || 0;
        let currentVal = parseFloat(modalQty.value) || 0;
        modalQty.value = Math.max(1, currentVal + add);
      } else if (setVal) {
        modalQty.value = setVal;
      }
    });
  });

  // Setup Resolve Store Modal Logic
  const modalResolveStore = container.querySelector('#modal-resolve-store');
  const btnCloseResolveStore = container.querySelector('#btn-close-resolve-store');
  const btnCancelResolveStore = container.querySelector('#btn-cancel-resolve-store');
  const btnSaveResolveStore = container.querySelector('#btn-save-resolve-store');
  const resolveStorePills = container.querySelector('#resolve-store-pills');
  const inputCustomStoreName = container.querySelector('#input-custom-store-name');

  let activePendingQuoteIDs = [];
  let activePendingEAN = '';
  let selectedResolveStoreName = '';

  async function openResolveStoreModal(quoteIDs, ean) {
    activePendingQuoteIDs = quoteIDs || [];
    activePendingEAN = ean || '';
    selectedResolveStoreName = '';
    if (inputCustomStoreName) inputCustomStoreName.value = '';

    const frequentStores = await getFrequentStoresFromNotas();
    const topStores = frequentStores.slice(0, 6);

    if (resolveStorePills) {
      if (topStores.length === 0) {
        resolveStorePills.innerHTML = '<span style="font-size: 0.76rem; color: var(--text-muted);">Nenhum estabelecimento frequente encontrado.</span>';
      } else {
        resolveStorePills.innerHTML = topStores.map(st => `
          <button type="button" class="btn-select-resolve-pill" data-store="${escapeHTML(st)}" style="padding: 0.3rem 0.65rem; border-radius: var(--radius-pill); font-size: 0.76rem; font-weight: 700; border: 1px solid var(--border-color); background: var(--bg-surface-alt); color: var(--text-main); cursor: pointer; display: inline-flex; align-items: center; gap: 0.25rem;">
            <span class="material-symbols-outlined" style="font-size: 13px;">shopping_cart</span>
            <span>${escapeHTML(st)}</span>
          </button>
        `).join('');

        resolveStorePills.querySelectorAll('.btn-select-resolve-pill').forEach(b => {
          b.addEventListener('click', () => {
            selectedResolveStoreName = b.getAttribute('data-store') || '';
            if (inputCustomStoreName) inputCustomStoreName.value = selectedResolveStoreName;
            resolveStorePills.querySelectorAll('.btn-select-resolve-pill').forEach(pill => {
              pill.style.background = 'var(--bg-surface-alt)';
              pill.style.color = 'var(--text-main)';
            });
            b.style.background = 'var(--color-primary, #2563EB)';
            b.style.color = '#FFF';
          });
        });
      }
    }

    if (modalResolveStore) modalResolveStore.classList.remove('hidden');
  }

  function closeResolveStoreModal() {
    if (modalResolveStore) modalResolveStore.classList.add('hidden');
    activePendingQuoteIDs = [];
    activePendingEAN = '';
    selectedResolveStoreName = '';
  }

  if (btnCloseResolveStore) btnCloseResolveStore.addEventListener('click', closeResolveStoreModal);
  if (btnCancelResolveStore) btnCancelResolveStore.addEventListener('click', closeResolveStoreModal);

  if (btnSaveResolveStore) {
    btnSaveResolveStore.addEventListener('click', async () => {
      const storeToSave = (inputCustomStoreName?.value || selectedResolveStoreName || '').trim();
      if (!storeToSave) {
        syncManager.showToast('Informe o nome do estabelecimento.', 'warning');
        inputCustomStoreName?.focus();
        return;
      }

      btnSaveResolveStore.disabled = true;
      btnSaveResolveStore.textContent = 'Salvando...';

      try {
        if (activePendingQuoteIDs.length > 0) {
          await resolvePendingCotacoes(activePendingQuoteIDs, storeToSave);
        } else if (activePendingEAN) {
          // If no specific IDs passed, query all pending quotes for this EAN
          const cotacoes = await getCotacoesByEAN(activePendingEAN);
          const pIds = (cotacoes || []).filter(c => c.statusEstabelecimento === 'pendente' || c.status_estabelecimento === 'pendente').map(c => c.id);
          if (pIds.length > 0) {
            await resolvePendingCotacoes(pIds, storeToSave);
          }
        }

        // Also update the local product record if exists
        const prod = allProdutos.find(p => (p.barcode || p.ean) === activePendingEAN);
        if (prod) {
          prod.ultimoMercado = storeToSave;
          prod.pendente_estabelecimento = false;
          prod.pendenteEstabelecimento = false;
          await saveProdutoScanned(prod);
        }

        closeResolveStoreModal();
        syncManager.showToast(`Estabelecimento definido como "${storeToSave}"!`, 'success');
        await loadData();
      } catch (err) {
        console.warn('Erro ao resolver estabelecimento:', err);
        syncManager.showToast('Falha ao salvar estabelecimento.', 'error');
      } finally {
        btnSaveResolveStore.disabled = false;
        btnSaveResolveStore.textContent = 'Confirmar';
      }
    });
  }

  // Setup Delete Product Modal Logic (Standard App Modal)
  const modalDeleteProd = container.querySelector('#modal-delete-prod-catalog');
  const deleteProdDesc = container.querySelector('#delete-prod-modal-desc');
  const btnCancelDeleteProd = container.querySelector('#btn-cancel-delete-prod');
  const btnConfirmDeleteProd = container.querySelector('#btn-confirm-delete-prod');
  let activeProdToDelete = null;

  function openDeleteModal(prod) {
    activeProdToDelete = prod;
    if (deleteProdDesc) {
      deleteProdDesc.textContent = prod.descricao || prod.ean || prod.barcode || 'este produto';
    }
    if (modalDeleteProd) modalDeleteProd.classList.remove('hidden');
  }

  function closeDeleteModal() {
    if (modalDeleteProd) modalDeleteProd.classList.add('hidden');
    activeProdToDelete = null;
  }

  if (btnCancelDeleteProd) btnCancelDeleteProd.addEventListener('click', closeDeleteModal);

  if (btnConfirmDeleteProd) {
    btnConfirmDeleteProd.addEventListener('click', async () => {
      if (!activeProdToDelete) return;
      const targetKey = activeProdToDelete.ean || activeProdToDelete.barcode || activeProdToDelete.id;
      const prodName = activeProdToDelete.descricao || targetKey;

      btnConfirmDeleteProd.disabled = true;
      btnConfirmDeleteProd.textContent = 'Excluindo...';

      try {
        await deleteProdutoScanned(targetKey);
        closeDeleteModal();
        syncManager.showToast(`Produto "${prodName}" excluído do catálogo.`, 'info');
        await loadData();
      } catch (err) {
        console.warn('Erro ao excluir produto:', err);
        syncManager.showToast('Falha ao excluir produto.', 'error');
      } finally {
        btnConfirmDeleteProd.disabled = false;
        btnConfirmDeleteProd.textContent = 'Sim, Excluir';
      }
    });
  }

  // Search input listener
  searchInput.addEventListener('input', (e) => {
    searchQuery = e.target.value;
    currentDisplayLimit = 30;
    renderList();
  });

  // Initial load
  await loadData();
}
